import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ResponseSnackbarService} from '../../services/response-snackbar.service';
import {GeneralConstant} from '../../constants/GeneralConstant';
import {HttpClient} from '@angular/common/http';
import {Subscription} from 'rxjs';
import * as FileSaver from 'file-saver';

export enum ExportType {
  PDF = 'pdf',
  XLS = 'xls',
  CSV = 'csv'
}

@Component({
  selector: 'app-table-exporter',
  templateUrl: './table-exporter.component.html',
  styleUrls: ['./table-exporter.component.scss']
})
export class TableExporterComponent {

  private subscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<TableExporterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private httpClient: HttpClient,
    private snackBar: ResponseSnackbarService
  ) {
    this.subscription = this.requestExport(data?.url, data?.params);
  }

  public cancelRequest() {
    this.subscription.unsubscribe();
    this.dialogRef.close();
  }

  private requestExport(url: string, params: any): Subscription {
    return this.httpClient.get(
      url,
      {params, responseType: 'arraybuffer'}
    ).subscribe(response => {
      if (params.type === 'pdf') {
        this.openFile(response, 'application/pdf');
      } else if (params.type === 'xls') {
        this.saveFile(response, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'xlsx');
      } else if (params.type === 'csv') {
        this.saveFile(response, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'csv');
      }
    });
  }

  public saveFile(data, type: string, ext: string) {
    FileSaver.saveAs(new Blob([data], {type}), `export_${new Date().getTime()}.${ext}`);
    this.dialogRef.close();
  }

  private openFile(data: any, type: string) {
    const blob = new Blob([data], {type});
    const url = window.URL.createObjectURL(blob);
    const pwa = window.open(url);
    this.dialogRef.close();
    if (!pwa || pwa.closed || typeof pwa.closed === 'undefined') {
      this.snackBar.onResponseMessage('Please disable your Pop-up blocker and try again.', GeneralConstant.SNACKBAR_ERROR_CLASS);
    }
  }
}
